<template>
  <div class="app-container">
    <div class="header">
      <div class="search" style="search-select;">
        <el-select v-model="searchHouseId" filterable placeholder="请选择楼盘">
          <el-option label="全部动态" value="all"> </el-option>
          <el-option
            v-for="item in houseData"
            :key="item.houseId"
            :label="item.houseName"
            :value="item.houseId"
          >
          </el-option>
        </el-select>
        <el-button
          icon="el-icon-search"
          size="small"
          @click="onSearch"
          style="margin: 0 10px"
          >查询</el-button
        >
        <el-button icon="el-icon-refresh" size="small" @click="onRefresh"
          >刷新</el-button
        >
      </div>
      <div>
        <el-button-group>
          <PermissionsBtn
            :icon="'el-icon-download'"
            :btnType="'primary'"
            :permissionName="'_Export'"
            :downloadUrl="'/productAdmin/House/downLoad_house_info'"
            :checkList="checkList"
          ></PermissionsBtn>
          <el-button
            style="margin-left: 10px"
            type="primary"
            icon="el-icon-plus"
            @click="onAdd"
            v-if="roleList[path].includes('_Add')"
            >新增</el-button
          >
          <el-button
            type="danger"
            icon="el-icon-delete"
            @click="onRemove"
            style="margin: 0 10px"
            v-if="roleList[path].includes('_Delete')"
            >批量删除</el-button
          >
          <!-- <download-excel
            :data="json_data"
            :fields="fields"
            worksheet="My Worksheet"
            name="导出数据.xls"
            style="display: inherit; margin-right: 10px"
          >
            <el-button icon="el-icon-download" size="small" type="primary"
              >批量导出</el-button
            >
          </download-excel> -->
        </el-button-group>
        <el-dropdown>
          <el-button type="success">
            更多菜单<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              @click.native="onChange('open')"
              v-if="roleList[path].includes('_Open')"
              >开启动态</el-dropdown-item
            >
            <el-dropdown-item
              @click.native="onChange('close')"
              v-if="roleList[path].includes('_Close')"
              >关闭动态</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <el-table
      v-loading="listLoading"
      height="750"
      :data="tableData"
      element-loading-text="loading"
      border
      fit
      highlight-current-row
      @selection-change="handleSelectionChange"
    >
      <el-table-column align="center" width="50" label="编号">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>

      <el-table-column type="selection" width="55"> </el-table-column>

      <el-table-column align="center" label="楼盘名">
        <template slot-scope="scope">
          {{ scope.row.houseName }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="动态标题">
        <template slot-scope="scope">
          {{ scope.row.title }}
        </template>
      </el-table-column>
      <el-table-column align="center" width="100" label="动态图片">
        <template slot-scope="scope">
          <img :src="scope.row.pic" style="width: 100%" />
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        width="500"
        label="动态正文"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.content }}
        </template>
      </el-table-column>
      <!-- <el-table-column align="center"  label="创建时间" prop="createTime" sortable>
                <template slot-scope="scope">
                    <div>{{ scope.row.createTime.split(' ')[0] }}</div>
                    <div>{{ scope.row.createTime.split(' ')[1] }}</div>
                </template>
            </el-table-column>
            <el-table-column align="center"  label="更新时间" prop="updateTime"  sortable>
                <template slot-scope="scope">
                    <div>{{ scope.row.updateTime.split(' ')[0] }}</div>
                    <div>{{ scope.row.updateTime.split(' ')[1] }}</div>
                </template>
            </el-table-column> -->
      <el-table-column align="center" label="动态排序" prop="sort" sortable>
        <template slot-scope="scope">
          {{ scope.row.sort }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="动态状态">
        <template slot-scope="scope">
          {{ scope.row.status === 1 ? '开启' : '关闭' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            @click="edit(scope)"
            v-if="roleList[path].includes('_Update')"
            >编辑</el-button
          >
          <el-button
            type="text"
            size="mini"
            @click="deleteNews(scope)"
            v-if="roleList[path].includes('_Delete')"
            >删除</el-button
          >
          <el-button
            v-if="scope.row.status === 1 && roleList[path].includes('_Close')"
            type="text"
            size="mini"
            @click="changeItem(scope, 'close')"
            >关闭</el-button
          >
          <el-button
            v-if="scope.row.status !== 1 && roleList[path].includes('_Open')"
            type="text"
            size="mini"
            @click="changeItem(scope, 'open')"
            >开启</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <Pagination ref="Pagination" />

    <editForm ref="editForm" />
  </div>
</template>

<script>
const editForm = () => import('./editForm');
import Pagination from '@/components/Pagination';
// import JsonExcel from 'vue-json-excel';

import {
  getHouseNewsList,
  getHouseNewsApi,
  removeHouseNewsApi,
  HouseNewsStatusApi,
} from '@/api/areaApi.js';
import { houseList } from '@/api/houseApi.js';
import { mapGetters } from 'vuex';
export default {
  components: {
    Pagination,
    editForm,
    // DownloadExcel: JsonExcel,
  },
  inject: ['reload'],
  data() {
    return {
      path: '',
      listLoading: false,
      tableData: [],
      houseId: '',
      searchHouseId: '',
      pageIndex: 1,
      pageSize: 10,
      multipleSelection: [],
      houseData: [],
      selectValue: '',
      selectLabel: '',
      fields: {},
      json_data: [
        {
          name: 'Tony Peña',
          city: 'New York',
          country: 'United States',
          birthdate: '1988-03-15',
          phone: {
            mobile: '1-338-888-8888',
            landline: '(541) 754-3010',
          },
        },
        {
          name: 'Thessaloniki',
          city: 'Athens',
          country: 'Greece',
          birthdate: '1987-11-22',
          phone: {
            mobile: '+1 333 888 8888',
            landline: '(2741) 2621-244',
          },
        },
      ],
      checkList: [],
      areaId: '',
    };
  },
  created() {
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
    this.areaId = localStorage.getItem('areaId')
      ? JSON.parse(localStorage.getItem('areaId')).areaId
      : '';
  },
  mounted() {
    this.houseId = this.$route.query.id;
    this.searchHouseId = this.$route.query.id;
    this.getList();
  },

  computed: {
    ...mapGetters(['paginObj', 'roleList']),
  },
  watch: {
    paginObj: 'getList',
  },
  methods: {
    async getList() {
      this.listLoading = true;

      await getHouseNewsList({
        houseId: this.houseId,
        //name: this.formInline.name,
        pageIndex: this.paginObj.pageIndex,
        pageSize: this.paginObj.pageSize,
        areaId: this.areaId,
      }).then((res) => {
        this.tableData = res.data.dataList;
        this.listLoading = false;
        this.pageIndex = res.data.pageIndex;
        this.pageSize = res.data.pageSize;
        this.$refs.Pagination.pageIndex = res.data.pageIndex;
        this.$refs.Pagination.pageSize = res.data.pageSize;
        this.$refs.Pagination.totalCount = res.data.totalCount;
      });

      try {
        houseList({
          areaId: this.areaId,
          name: '',
          isExport: true,
        }).then((res) => {
          this.houseData = res.data.dataList;
        });
      } catch (e) {
        window.console.log(e);
      }
    },
    //选中
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.checkList =
        val.length &&
        val.map((item) => {
          return item.newsId;
        });
    },
    //搜索
    onSearch() {
      if (this.searchHouseId === 'all') {
        this.houseId = '';
      } else {
        this.houseId = this.searchHouseId;
      }

      this.getList();
    },
    //刷新
    onRefresh() {
      this.reload();
    },
    //新增
    onAdd() {
      this.$refs.editForm.dialogTitle = '新增楼盘动态';
      this.$refs.editForm.dialogFormVisible = true;
      this.$refs.editForm.houseId = this.houseId;
      this.$refs.editForm.houseData = this.houseData;
      this.$refs.editForm.editForm = { houseId: this.houseId };
    },
    //批量删除
    onRemove() {
      let checkIds = [];
      this.multipleSelection.forEach((item) => {
        checkIds.push(item.newsId);
      });
      this.funcRemove(checkIds);
    },
    //批量导出
    async fetchData() {
      let idList = [];
      this.multipleSelection.forEach((item) => {
        idList.push(item.newsId);
      });
      this.listLoading = true;
      await getHouseNewsList({
        houseId: this.houseId,
        idList,
        isExport: idList.length == 0,
        areaId: this.areaId,
      }).then((res) => {
        if (res.code !== 200) return [];
        console.log('需要导出的数据', res.data.dataList);
        this.listLoading = false;
        return res.data.dataList;
      });
    },
    //编辑
    edit(scope) {
      this.$refs.editForm.dialogTitle = '编辑楼盘动态';
      this.$refs.editForm.dialogFormVisible = true;
      this.$refs.editForm.houseId = scope.row.houseId;
      this.$refs.editForm.houseNewsId = scope.row.newsId;
      // this.$refs.editForm.newsData = tableData;
      this.$refs.editForm.houseData = this.houseData;
      getHouseNewsApi(scope.row.newsId).then((res) => {
        const houseIndex = this.houseData.findIndex(
          (child) => child.houseId == res.data.houseId
        );
        if (houseIndex == -1)
          this.$refs.editForm.editForm = { ...res.data, houseId: '' };
        else {
          this.$refs.editForm.editForm = { ...res.data };
        }
      });
    },
    //单条删除
    deleteNews(scope) {
      let checkIds = [];
      checkIds.push(scope.row.newsId);
      this.funcRemove(checkIds);
    },
    funcRemove: function (checkIds) {
      try {
        if (checkIds.length === 0) {
          return this.$message.error('请选择要删除的数据！');
        }
        this.$confirm('是否狠心删除该数据', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error',
        })
          .then(async () => {
            await removeHouseNewsApi(checkIds).then((res) => {
              if (res.code === 200) {
                this.onRefresh();
                this.$message.success('删除成功!');
              } else {
                this.$message.info('删除失败：' + res.message);
              }
            });
          })
          .catch(() => {
            this.$message.info('删除出错');
          });
      } catch (e) {
        this.$message.info('删除出错:' + e.message);
        window.console.log(e);
      }
    },
    //格式转换,不需要改动
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    //关闭
    changeItem(scope, type) {
      let checkIds = [];
      checkIds.push(scope.row.newsId);
      this.changeStatus(checkIds, type);
    },
    onChange(type) {
      let checkIds = [];
      this.multipleSelection.forEach((item) => {
        checkIds.push(item.newsId);
      });
      this.changeStatus(checkIds, type);
    },
    changeStatus(checkIds, type) {
      try {
        if (checkIds.length === 0) {
          return this.$message.error('请选择要更改的数据！');
        }
        this.$confirm('是否更改选中动态状态', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error',
        })
          .then(async () => {
            await HouseNewsStatusApi(checkIds, type).then((res) => {
              if (res.code === 200) {
                this.onRefresh();
                this.$message.success('更改成功!');
              } else {
                this.$message.info('更改失败：' + res.message);
              }
            });
          })
          .catch(() => {
            this.$message.info('更改出错');
          });
      } catch (e) {
        this.$message.info('更改出错出错:' + e.message);
        window.console.log(e);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.app-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  .search {
    display: flex;
    width: 800px;

    .search-input {
      margin: 0 10px;
      width: 300px;
    }

    .search-picker {
      width: 250px;
    }

    .search-select {
      margin-right: 10px;
    }
  }

  button {
    height: 40px;
  }
}
</style>
